
<ng-container>
  <nb-card>
    <nb-card-body>
      <app-ng-material-form
        *ngIf="formRender"
        [renderFormField]="filterForm"
        [formSubmitFromParent]="submitFilterForm"
        (sentFormToParent)="listenFilterForm($event)"
      ></app-ng-material-form>
    </nb-card-body>

    <nb-card-footer class="text-right">
      <button mat-button type="reset" (click)="onReset()" color="warn"><i class="bi bi-x-circle"></i> Clear</button>
      <button class="ml-2" mat-flat-button color="primary" type="submit" (click)="onSubmit()"><i class="bi bi-search"></i> Search</button>
    </nb-card-footer>
  </nb-card>

</ng-container>
